import api from "./api";

export const orderService = {
  getAll: async () => {
    const res = await api.get("/orders");
    return res.data;
  },

  getById: async (id: string) => {
    const res = await api.get(`/orders/${id}`, {
      withCredentials: true,
    });
    return res.data;
  },

  create: async (formData: FormData) => {
    const res = await api.post("/orders", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  },

  update: async (id: string, payload: any) => {
    // If payload is FormData → send multipart
    if (payload instanceof FormData) {
      const res = await api.put(`/orders/${id}`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    }

    // Otherwise send normal JSON
    const res = await api.put(`/orders/${id}`, payload);
    return res.data;
  },


  delete: async (id: string) => {
    const res = await api.delete(`/orders/${id}`);
    return res.data;
  },

  track: (email: string, orderId: string) => {
    return api.get(`/orders/${orderId}`, { params: { email, orderId } });
  },
};
